module.exports = __webpack_public_path__ + "img/antes_despues_221.0beb3510.png";